import { IMemberLoginHistoryModel } from "features/dashboard/api/types";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  AreaChart,
  Area,
  ResponsiveContainer,
} from "recharts";
import dayjs from "dayjs";
import { Box, Typography } from "@mui/material";

type Props = {
  data: IMemberLoginHistoryModel[];
};

const LoginHistoryChart = ({ data }: Props) => {
  const loginData = data?.map((d) => ({
    name: dayjs(d.loginDate).format("DD - MMM"),
    members: d.members,
  }));
  return (
    <>
      <div style={{ width: "100%" }}>
        <ResponsiveContainer width="100%" height={250}>
          {data[0] ? (
            <AreaChart
              width={500}
              height={500}
              data={loginData}
              syncId="anyId"
              margin={{
                top: 10,
                right: 30,
                left: 0,
                bottom: 0,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Area
                type="monotone"
                dataKey="members"
                stroke="#82ca9d"
                fill="#82ca9d"
              />
            </AreaChart>
          ) : (
            <>
              <Box sx={{ justifyItems: "center", p: 10 }}>
                <Typography>No data to display!!</Typography>
              </Box>
            </>
          )}
        </ResponsiveContainer>
      </div>
    </>
  );
};

export default LoginHistoryChart;
